define('app/views/interest_tracker',['app/setup'], function (takhfifan) {
  takhfifan.InterestNotifier = takhfifan.BaseView.extend({
    initialize: function (options) {
      var _this = this;
      this.value = this.$el.data('interestValue');
      this.type = this.$el.data('interestType');
      this.timePeriod = parseInt(this.$el.data('interestPeriod'),10);
      this.mode = this.$el.data('interestMode');
      this.removeUrl = options.removeUrl;
      this.addUrl = options.addUrl;

      this.userId = undefined;
      takhfifan.eventHub.on('onesignal:loaded',function(){
        _this.activateTracker();
      },this);
      _this.activateTracker();
    },

    activateTracker:function () {
      var _this = this;
      window.OneSignal &&  window.OneSignal.getUserId(function(userId) {
        _this.userId = userId;
        if(_this.mode==="remove"){
          _this.unTrackMe();
        }else{
          _this.initTracking();
        }
      });

    },

    initTracking: function(){
      var _this = this;
      if(!this.isTracking()){
        this.checkForTracking();
      }

      var productsOnPage = [];
      if($('#tkh-grouped-products-data').length){
        var subDealsData = JSON.parse($('#tkh-grouped-products-data').val());
        _.each(subDealsData, function(subDealData){
          productsOnPage.push(subDealData.id);
        });
      }

      $('.tkh-sale').each(function() {
        productsOnPage.push(parseInt($(this).data('product-id')));
      });

      _.each(productsOnPage,function (productId) {
        takhfifan.eventHub.on('productaddtocart:' + productId, function(opts) {
          if(productId === _this.value || (opts && opts.parentProductId && opts.parentProductId === _this.value)){
            _this.unTrackMe();
          }
        });
      });

      takhfifan.eventHub.on('productaddtocart:configurable', function(opts) {
        if(opts && opts.parentProductId && opts.parentProductId === _this.value){
          _this.unTrackMe();
        }
      });

    },

    isTracking: function () {
      return $.cookie('tkh-i-'+this.value) === this.type;
    },

    checkForTracking: function () {
      var _this = this;
      setTimeout(function(){
        _this.trackMe();
      }, this.timePeriod * 1000);
    },
    
    trackMe: function () {
      var _this = this;
      $.ajax({
        url: this.addUrl,
        data: {
          player_id: this.userId,
          type: this.type,
          value: this.value
        },
        success: function () {
          $.cookie('tkh-i-'+_this.value,_this.type,{ expires: 0.041, path: '/' });
        }
      });
    },

    unTrackMe: function () {
      var _this = this;
      $.cookie('tkh-i-remove', this.value+"___"+this.type+"___"+this.userId,{ expires: 0.041, path: '/' });
      if(this.isTracking()){
        $.ajax({
          url: this.removeUrl,
          data: {
            player_id: this.userId,
            type: this.type,
            value: this.value
          },
          success: function () {
            $.removeCookie('tkh-i-'+_this.value);
            $.removeCookie('tkh-i-remove');
          }
        });
      }
    }
    
  });
});




